export default __webpack_public_path__ + "static/media/betterDocsAiimg.3d2c2f20.svg";